import React, { useEffect } from "react";
// import PlansGrid from "./PlansGrid";
import styled from "styled-components";
import FabricIcon from "@components/Icons/FabricIcon";

const ProposalWrapper = styled.div`
	h3,
	h4 {
		font-size: 1.2em;
		padding: 0;
		margin: 0;
	}

	h2 h5 {
		font-size: 1.1em;
		margin-top: 1.7em;
	}

	p,
	a {
		vertical-align: middle;
		margin-bottom: 0.1em;
	}

	.overview-maps-container ul {
		list-style: none;
		display: flex;
		flex-direction: row;
		margin: 0;
		padding-left: 0.5em;
	}

	.overview-maps-container li {
		margin: 0.3em 0.7em;
	}

	.overview-maps-container h4 {
		margin-top: auto;
		margin-bottom: auto;
		min-width: 240px;
		font-size: 1.2em;
	}

	@media (max-width: 415px) {
		.overview-maps-container ul {
			flex-direction: column;
		}
	}
`;

const CollapseHeaderWrapper = styled.div`
	h3 {
		font-size: 1.4em;
		margin: 0;
		padding: 0.3em;
		text-align: left;
	}

	h4 {
		font-size: 1.1em;
		margin: 0.5em 0;
		padding: 0.3em;
	}

	button i {
		transition: all 300ms ease;
	}

	button.collapsed i {
		transform: rotate(-180deg);
	}

	button h2 + div > i {
		font-size: 1.5em;
	}

	button h4 + div > i {
		font-size: 1.2em;
	}
`;

const CollapseHeader = props => {
	const { targetId, children, className } = props;
	return (
		<CollapseHeaderWrapper>
			<button
				{...props}
				data-toggle="collapse"
				data-target={`#${targetId}`}
				aria-controls={targetId}
				className={`btn btn-link w-100 ml-lg-1 m-0 p-0 d-flex flex-row justify-content-between text-left align-items-center collapsed${
					className ? " " + className : ""
				}`}
			>
				{children}
				<div className="text-decoration-none font-weight-bolder">
					<FabricIcon iconName="ChevronUpMed" />
				</div>
			</button>
		</CollapseHeaderWrapper>
	);
};

// Remove per Research request
// const ProposalGroup = ({ mapGroups, title, targetId }) => {
// 	return (
// 		<div className="card">
// 			<div className="card-header py-0 px-3">
// 				<CollapseHeader targetId={targetId}>{title}</CollapseHeader>
// 			</div>
// 			<div
// 				className="card-body collapse pt-0 px-sm-3 px-lg-5"
// 				id={targetId}
// 			>
// 				{mapGroups.map((group, i) => (
// 					<div key={`targetId-${i}`}>
// 						<div className="pl-1 pl-lg-0">{group.title}</div>
// 						<PlansGrid plans={group.groups} />
// 					</div>
// 				))}
// 			</div>
// 		</div>
// 	);
// };

const Proposal = ({ proposal, id }) => {
	const proposalHeaderId = `header-${id}`;
	const collapseContainerId = `collapseible-${id}`;
	// const proposalsGroupContainerId = `proposal-group-container-${id}`;

	return (
		<ProposalWrapper className="proposal-wrapper">
			<div className="card">
				<div className="card-header p-0">
					<CollapseHeader
						className="m-0 py-2 w-100 pr-3"
						targetId={collapseContainerId}
						id={proposalHeaderId}
					>
						{proposal.title}
					</CollapseHeader>
				</div>
				<div
					className="collapse"
					id={`${collapseContainerId}`}
					aria-labelledby={proposalHeaderId}
				>
					<div className={`card-body p-2 pb-4 px-sm-4 px-lg-5`}>
						{proposal.billLink ? (
							<a
								className="pt-3 d-block"
								href={proposal.billLink}
							>
								View {proposal.titlePlainText} on NELIS
							</a>
						) : null}

						<div className="overview-maps-container my-4">
							{proposal.overviewMaps.map(({ title, maps }, i) => (
								<div
									className="d-md-flex"
									key={`overview-map-${id}-${i}`}
								>
									{title}
									{maps}
								</div>
							))}
						</div>

						{/* Remove per research request 
						<h3 id={`individual-maps-${id}`} className="my-4">
							Individual District Maps
						</h3>

						<div id={proposalsGroupContainerId}>
							{proposal.proposals.map(
								({ title, mapGroups }, i) => (
									<ProposalGroup
										title={title}
										mapGroups={mapGroups}
										key={`${proposalsGroupContainerId}-${i}`}
										targetId={`${proposalsGroupContainerId}-${i}`}
									/>
								)
							)}
						</div> */}
					</div>
				</div>
			</div>
		</ProposalWrapper>
	);
};

const scrollToAndExpandCollapsableRegion = (heading, container) => {
	heading.scrollIntoView();

	const collapseContainer = container.querySelectorAll(".collapse")[0];

	if (!collapseContainer.classList.contains("show")) {
		collapseContainer.classList.add("show");
	}

	const parentCollapse = container.querySelectorAll(
		'[data-toggle="collapse"]'
	)[0];
	if (parentCollapse.classList.contains("collapsed")) {
		parentCollapse.classList.remove("collapsed");
	}

	const parent = heading.parentElement;
	if (parent.dataset.toggle === "collapse") {
		const collapseTarget = document.querySelector(parent.dataset.target);
		if (collapseTarget && !collapseTarget.classList.contains("show")) {
			collapseTarget.classList.add("show");
		}
		if (parent.classList.contains("collapsed")) {
			parent.classList.remove("collapsed");
		}
	}
};

const useScrollToCollapsableHeadings = (containersQuery, location) => {
	useEffect(() => {
		const proposalContainers = document.querySelectorAll(containersQuery);

		for (let i = 0; i < proposalContainers.length; i++) {
			const heading =
				location.hash !== ""
					? proposalContainers[i].querySelector(location.hash)
					: null;

			if (heading) {
				scrollToAndExpandCollapsableRegion(
					heading,
					proposalContainers[i]
				);
				break;
			}
		}
	});
};

const ProposedPlans = ({ data: { proposals, mainBodyText }, location }) => {
	const proposalGroups = proposals
		? Object.keys(proposals).map(k => ({
				proposal: proposals[k],
				id: k,
		  }))
		: null;

	useScrollToCollapsableHeadings(".proposal-wrapper", location);

	return (
		<div className="mt-5">
			{mainBodyText}
			{proposals ? (
				proposalGroups.map(({ proposal, id }) => (
					<div key={id}>
						{proposal.type == "group" ? (
							<Proposal id={id} proposal={proposal} />
						) : (
							<div>{proposal.body}</div>
						)}
					</div>
				))
			) : (
				<div></div>
			)}
		</div>
	);
};

export default ProposedPlans;
